import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { siteSettings } from "@/content/site";
import { ArrowRight, CheckCircle, Star } from "@phosphor-icons/react";

const PACKS = [
  {
    slug: "standard",
    name: "Standard",
    claim: "Essenziale, funzionale, ben fatto",
    chi: "Pensato per chi vuole rinnovare il bagno con una soluzione semplice, ordinata e concreta, senza rinunciare alla qualità dell'esecuzione.",
    include: ["Scelte guidate", "Materiali coordinati", "Garanzia standard", "2 tipologie di piastrelle selezionabili", "Computo metrico", "Organizzazione del lavoro", "Nessuna sorpresa"],
    cta: "Scopri se Standard è adatto al tuo bagno",
  },
  {
    slug: "superior",
    name: "Superior",
    badge: "Il più equilibrato",
    claim: "Più qualità, più comfort, più serenità",
    chi: "Pensato per chi vuole un bagno curato, pratico e più completo, con finiture migliori e soluzioni pensate per durare nel tempo.",
    include: ["Tutto ciò che è previsto nello Standard", "Super Garanzia", "Rubinetterie con risparmio energetico", "Aeratore anticalcare", "Ottone e finiture di pregio", "Docce con trattamento anticalcare", "3 scelte di piastrelle", "Maggiore cura nei dettagli"],
    cta: "Voglio un bagno più completo",
  },
  {
    slug: "exclusive",
    name: "Exclusive",
    claim: "Estetica, efficienza e sensazione di lusso",
    chi: "Pensato per chi vuole un bagno più ricercato, comodo da vivere e facile da mantenere nel tempo.",
    include: ["Tutto ciò che è previsto nel Superior", "Sanitari con trattamento antibatterico", "Trattamento impermeabilizzante per facilitare la pulizia", "Finiture più curate", "Maggiore attenzione estetica", "Esperienza più completa"],
    cta: "Voglio valutare una soluzione Exclusive",
  },
];

export default function Pacchetti() {
  return (
    <div className="bg-warm-white min-h-screen">
      <Navbar />
      <section className="section-pad">
        <div className="max-w-6xl mx-auto px-5 md:px-10">
          <div className="text-center mb-14">
            <div className="overline mb-4">Pacchetti</div>
            <h1 className="font-display text-4xl md:text-6xl leading-tight">Tre livelli, un solo metodo.</h1>
            <p className="mt-5 text-[#5C5C59] max-w-3xl mx-auto">Ogni bagno ha esigenze diverse. Per questo abbiamo creato tre percorsi, pensati per aiutarti a scegliere con più chiarezza. Non mostriamo prezzi sul sito: il valore reale dipende da misure, impianti, accessi, materiali e condizioni del bagno.</p>
          </div>
          <div className="space-y-10">
            {PACKS.map((p) => (
              <div key={p.slug} className={`card-soft p-7 md:p-10 grid md:grid-cols-3 gap-8 ${p.badge ? "ring-1 ring-[var(--oasi-green)]" : ""}`} data-testid={`pkg-${p.slug}`}>
                <div className="md:col-span-1">
                  {p.badge && (
                    <div className="inline-flex items-center gap-1 bg-oasi-green text-white text-[11px] tracking-[0.18em] uppercase px-3 py-1 rounded-full mb-3">
                      <Star size={12} weight="fill" /> {p.badge}
                    </div>
                  )}
                  <h2 className="font-display text-4xl mb-2">{p.name}</h2>
                  <div className="text-oasi-green text-sm mb-4">{p.claim}</div>
                </div>
                <div className="md:col-span-2">
                  <div className="overline mb-2">A chi è adatto</div>
                  <p className="text-[#5C5C59] mb-6 leading-relaxed">{p.chi}</p>
                  <div className="overline mb-2">Include</div>
                  <ul className="space-y-2 mb-6">
                    {p.include.map((f, i) => (
                      <li key={i} className="flex gap-2 text-sm">
                        <CheckCircle size={16} weight="fill" className="text-oasi-green mt-0.5 flex-shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                  <Link to="/prenota-sopralluogo" className={`inline-flex items-center text-center gap-2 px-6 py-3 rounded-full text-sm leading-snug ${p.badge ? "btn-primary" : "btn-outline"}`}>
                    {p.cta} <ArrowRight size={14} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer settings={siteSettings} />
      <WhatsAppFloat number={siteSettings.whatsapp_number} />
    </div>
  );
}
